import { render, staticRenderFns } from "./AppRadioGroup.vue?vue&type=template&id=aa583656&scoped=true&"
import script from "./AppRadioGroup.vue?vue&type=script&lang=js&"
export * from "./AppRadioGroup.vue?vue&type=script&lang=js&"
import style0 from "./AppRadioGroup.vue?vue&type=style&index=0&id=aa583656&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aa583656",
  null
  
)

export default component.exports